import React, { useCallback, useContext } from 'react'
import { Col, Row, Card, Button } from '@themesberg/react-bootstrap'
import { Context } from '..'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'OPEN_ADD_POPUP',
    })
  }, [dispatch])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>Nhóm quảng cáo</h5>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="success" type="submit" onClick={_submitForm}>Thêm</Button>
            </Col>
          </Row>
        </Card.Header>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)